import { HttpService } from './../../Services/http.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { CountryItemDto } from '../../models/dto/country-item.dto';

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.css']
})
export class CountrySelectComponent implements OnInit, OnChanges {
  form: UntypedFormGroup;
  countryList: CountryItemDto[] = [];
  showControl = false;
  @Input() id: string;
  @Input() header: string;
  @Input() placeholder: string;
  @Input() error_msg: string;
  @Output() emit = new EventEmitter<AbstractControl>();

  constructor(
    private fb: UntypedFormBuilder,
    private http: HttpService) {
    this.form = this.fb.group({
      country: [null, Validators.required]
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes){
      this.countryControl.setValue(this.id);
      this.emit.emit(this.countryControl);
    }
  }

  get countryControl() {
    return this.form.controls['country'];
  }

  ngOnInit(): void {
    this.http.getCountriesList().subscribe((resp)=>{
      this.countryList = resp;
      this.showControl = true;
    })
  }

  touchForm(){
    this.emit.emit(this.countryControl);
    this.form.markAllAsTouched();
  }

}
